module.exports = __webpack_public_path__ + "img/case1.0e3e4d62.png";